import {
    ComplectationCreateForm,
    ComplectationCreateFormErrors, ComplectationCreateFormErrorsSchema,
} from '@/types/complectation/complectation-create-form.type.ts';

export type ComplectationUpdateForm = ComplectationCreateForm;

export type ComplectationUpdateFormErrors = ComplectationCreateFormErrors;

export const ComplectationUpdateFormErrorsSchema = ComplectationCreateFormErrorsSchema;
